module.exports = __webpack_public_path__ + "img/search-adapt.cc549c94.svg";